import { render } from "./ConversationEventConfiguration.vue?vue&type=template&id=4b750596&scoped=true&lang=pug"
import script from "./ConversationEventConfiguration.vue?vue&type=script&lang=js"
export * from "./ConversationEventConfiguration.vue?vue&type=script&lang=js"

import "./ConversationEventConfiguration.vue?vue&type=style&index=0&id=4b750596&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b750596"]])

export default __exports__